import DashboardLayout from "../layout/DashboardLayout.vue";
// GeneralViews
import Login from "../pages/LoginSection.vue";

// Admin pages
import Overview from "src/pages/OverviewPage.vue";
import Roles from "src/pages/Roles/RolesList.vue";
import Users from "src/pages/Users/UsersList.vue";
import AvlList from "@/pages/Avl/AvlList";
import ChipsList from "@/pages/Chips/ChipsList";
import ClientesList from "@/pages/Clientes/ClientesList";
import EstadoDeCuentasIndex from "@/pages/Cuentas/EstadoDeCuentasIndex";
import PagosPage from "@/pages/Pagos/PagosPage";
import EvitarSuspensiones from "@/pages/Suspensiones/EvitarSuspensiones";
import TratamientoDeSuspensiones from "@/pages/Suspensiones/TratamientoDeSuspensiones";
import CajaHolder from "../pages/Caja/CajaHolder";
import CajaComponent from "../pages/Caja/CajaComponent";
import ClientesHolder from "../pages/Clientes/ClientesHolder";
import ModificarCliente from "../pages/Clientes/ModificarCliente.vue";
import Empresas from "@/pages/Clientes/Empresas/EmpresasList.vue";
import ContratosList from "@/pages/Clientes/Contratos/ContratosList";
import CrearContrato from "@/pages/Clientes/Contratos/CrearContrato";
import ContratosHolder from "@/pages/Clientes/Contratos/ContratosHolder";
import CrearCliente from "@/pages/Clientes/CrearCliente";
import ModificarContrato from "@/pages/Clientes/Contratos/ModificarContrato";
import UsuariosHolder from "@/pages/Users/UsuariosHolder";
import ModificarUsuario from "src/pages/Users/ModificarUsuario";
import ModificarRol from "@/pages/Roles/Update/ModificarRol";
import RolesHolder from "@/pages/Roles/RolesHolder";
import AsignarRoles from "@/pages/Users/Update/AsignarRoles";
import SuspensionesHolder from "../pages/Suspensiones/SuspensionesHolder.vue";
import EvitarSuspensionesHolder from "../pages/Suspensiones/EvitarSuspensiones/EvitarSuspensionesHolder.vue";
import HistorialDeTickets from "../pages/Suspensiones/EvitarSuspensiones/Tickets/HistorialDeTickets.vue";
import EditarTicket from "../pages/Suspensiones/EvitarSuspensiones/Tickets/Historial/EditarTicket.vue";
import HistorialDeTicketsHolder from "../pages/Suspensiones/EvitarSuspensiones/Tickets/Historial/HistorialDeTicketsHolder.vue";
import CuentaDeCliente from "../pages/Clientes/Cuenta/CuentaDeCliente.vue";
import AccesoParaTesteosList from "../pages/AccesoParaContratos/AccesoParaTesteosList.vue";
import VehiculosParaRevisionTecnica from "../pages/AccesoParaContratos/VehiculosParaRevisionTecnica.vue";
import VehiculosHolder from "../pages/AccesoParaContratos/VehiculosHolder.vue";
import FacturasYNotasDeCredito from "../pages/Clientes/Facturas/FacturasYNotasDeCredito.vue";
import AvlHolder from "../pages/Avl/AvlHolder.vue";
import HistorialAvls from "../pages/Avl/HistoralAvls.vue";
import HistorialContratos from "../pages/Clientes/HistorialContratos.vue";
import Rapipago from "../pages/Pagos/Rapipago/IngresoPagosRapipago.vue";
import PagosHolder from "../pages/Pagos/PagosHolder.vue";
import ParametrosLocalesHolder from "../pages/ParametrosLocales/ParametrosLocalesHolder.vue";
import ParametrosLocales from "../pages/ParametrosLocales/ParametrosLocalesForm.vue";
import HistorialDeMantenimientos from "../pages/Clientes/Contratos/HistorialDeMantenimientos.vue";
import InformeCoberturaGsm from "../pages/Tools/InformeCoberturaGsm.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/login",
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/admin",
    component: DashboardLayout,
    redirect: "/admin/overview",
    children: [
      {
        path: "overview",
        name: "Overview",
        component: Overview,
      },
      {
        path: "roles",
        name: "Roles",
        component: RolesHolder,
        children: [
          {
            path: "/",
            name: "ABM Roles & Permisos",
            component: Roles,
          },

          {
            path: ":id_rol",
            name: "Modificar Rol",
            component: ModificarRol,
          },
        ],
      },
      {
        path: "parametros-locales",
        name: "Parametros locales",
        component: ParametrosLocalesHolder,
        children: [
          {
            path: "/",
            name: "Parametros locales",
            component: ParametrosLocales,
          },
        ],
      },
      {
        path: "users",
        name: "Usuarios",
        component: UsuariosHolder,
        children: [
          {
            name: "ABM Usuarios",
            path: "/",
            component: Users,
          },
          {
            name: "Modificar Usuario",
            path: ":id_usuario",
            component: ModificarUsuario,
          },
          {
            name: "Asignar Roles",
            path: ":id_usuario/roles",
            component: AsignarRoles,
          },
        ],
      },
      {
        path: "avl",
        name: "AVL",
        component: AvlHolder,
        children: [
          { name: "List AVLS", path: "/", component: AvlList },
          {
            name: "Historial de AVLS",
            path: "historial-avls",
            component: HistorialAvls,
          },
        ],
      },
      {
        path: "chips",
        name: "Chips",
        component: ChipsList,
      },
      {
        path: "clientes",
        name: "Clientes",
        component: ClientesHolder,
        children: [
          {
            name: "Clientes Index",
            path: "/",
            component: ClientesList,
          },
          {
            name: "Nuevo Cliente",
            path: "nuevo",
            component: CrearCliente,
          },
          {
            name: "Historial Contratos",
            path: "historial-contratos",
            component: HistorialContratos,
          },
          {
            name: "Modificar Cliente",
            path: ":id_cliente",
            component: ModificarCliente,
          },
          {
            name: "Empresas",
            path: ":id_cliente/empresas",
            component: Empresas,
          },
          {
            name: "Cuenta de Cliente",
            path: ":id_cliente/cuenta",
            component: CuentaDeCliente,
          },
          {
            name: "Facturas y notas de credito",
            path: ":id_cliente/facturas-y-notas-de-credito",
            component: FacturasYNotasDeCredito,
          },
          {
            name: "Contratos",
            path: ":id_cliente/contratos",
            component: ContratosHolder,
            children: [
              {
                name: "Contratos",
                path: "",
                component: ContratosList,
              },
              {
                name: "Nuevo Contrato",
                path: "nuevo",
                component: CrearContrato,
              },
              {
                name: "Historial de Mantenimientos",
                path: "historial-de-mantenimientos",
                component: HistorialDeMantenimientos,
              },
              {
                name: "modificar-contrato",
                path: ":id_contrato",
                component: ModificarContrato,
              },
            ],
          },
        ],
      },
      {
        name: "Testeos",
        path: "acceso-testeos",
        component: VehiculosHolder,
        children: [
          {
            name: "Testeos de vehiculos",
            path: "",
            component: AccesoParaTesteosList,
          },
          {
            name: "Vehiculos",
            path: "vehiculos",
            component: VehiculosParaRevisionTecnica,
          },
        ],
      },
      {
        name: "Testeos",
        path: "acceso-testeos",
        component: AccesoParaTesteosList,
        children: [],
      },
      {
        path: "cuentas",
        name: "Cuentas",
        component: EstadoDeCuentasIndex,
      },
      {
        path: "pagos",
        name: "Pagos",
        component: PagosHolder,
        children: [
          { path: "", name: "Modulo de Pagos", component: PagosPage },
          { path: "rapipago", name: "Rapipago", component: Rapipago },
        ],
      },
      {
        path: "suspensiones",
        component: SuspensionesHolder,
        children: [
          {
            name: "Evitar",
            path: "evitar",
            component: EvitarSuspensionesHolder,
            children: [
              {
                name: "Evitar Suspensiones",
                path: "",
                component: EvitarSuspensiones,
              },
              {
                name: "Historial",
                path: ":id_cliente/historial",
                component: HistorialDeTicketsHolder,
                children: [
                  {
                    name: "Historial de Tickets",
                    path: "",
                    component: HistorialDeTickets,
                  },
                  {
                    name: "Editar ticket ",
                    path: ":id_ticket/editar",
                    component: EditarTicket,
                  },
                ],
              },
            ],
          },
          {
            name: "Tratamiento",
            path: "tratamiento",
            component: TratamientoDeSuspensiones,
            children: [
              {
                name: "Tratamiento de Suspensiones",
                path: "",
                component: EvitarSuspensiones,
              },
              {
                path: ":id_cliente/historial",
                component: HistorialDeTicketsHolder,
                children: [
                  {
                    path: "",
                    component: HistorialDeTickets,
                  },
                  {
                    path: ":id_ticket/editar",
                    component: EditarTicket,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "caja",
        redirect: "/admin/caja",
        component: CajaHolder,
        children: [
          {
            path: "/",
            component: CajaComponent,
          },
        ],
      },
      {
        path: "tools/cobertura-gsm",
        name: "Informe Cobertura GSM",
        component: InformeCoberturaGsm,
      },
    ],
  },
  { path: "*", redirect: "/admin/overview" },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
